import { useState } from "react";
import { X } from "lucide-react";

const CHANNEL_URL = "https://whatsapp.com/channel/0029Vb84xGGK0IBkuFBuLw0s";

const WhatsAppIcon = ({ size = 26 }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill="#fff" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0012.06 0C5.5 0 .18 5.33.18 11.89c0 2.1.55 4.15 1.6 5.96L0 24l6.35-1.66a11.85 11.85 0 005.7 1.45h.01c6.55 0 11.88-5.33 11.88-11.89 0-3.18-1.24-6.17-3.42-8.42zM12.06 21.79h-.01a9.9 9.9 0 01-5.05-1.39l-.36-.21-3.77.99 1.01-3.68-.24-.38a9.87 9.87 0 01-1.52-5.24c0-5.45 4.44-9.88 9.9-9.88 2.64 0 5.13 1.03 6.99 2.9a9.83 9.83 0 012.9 6.99c-.01 5.46-4.44 9.9-9.85 9.9zm5.44-7.4c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.66.15-.2.3-.76.97-.94 1.17-.17.2-.34.22-.64.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.6.13-.13.3-.34.44-.51.15-.17.2-.29.3-.48.1-.2.05-.37-.02-.52-.07-.15-.66-1.6-.9-2.19-.24-.57-.48-.49-.66-.5l-.56-.01c-.2 0-.51.07-.78.37-.27.3-1.02.99-1.02 2.41 0 1.42 1.04 2.79 1.19 2.98.15.2 2.05 3.14 4.98 4.4.69.3 1.24.48 1.66.61.7.22 1.33.19 1.83.11.56-.08 1.72-.7 1.96-1.38.24-.68.24-1.26.17-1.38-.07-.12-.27-.2-.57-.35z" />
    </svg>
);

export default function WhatsAppButton() {
    const [open, setOpen] = useState(true);

    if (!open) {
        return (
            <a
                href={CHANNEL_URL}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="whatsapp-cta-fab"
                className="fixed right-4 md:right-6 bottom-4 md:bottom-6 z-40 w-14 h-14 bg-[#25D366] text-white rounded-full flex items-center justify-center shadow-2xl hover:scale-105 active:scale-95 transition-transform"
                aria-label="انضم لقناة واتساب"
            >
                <WhatsAppIcon size={26} />
            </a>
        );
    }

    return (
        <a
            href={CHANNEL_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="whatsapp-cta-card"
            className="fixed right-3 md:right-6 bottom-3 md:bottom-6 z-40 flex items-center gap-3 md:gap-4 bg-[#0F2A28] text-white rounded-2xl shadow-2xl p-3 md:p-4 md:pe-5 border border-[#25D366]/30 hover:scale-[1.02] active:scale-[0.99] transition-transform group max-w-[calc(100vw-24px)] md:max-w-[360px]"
        >
            <span className="shrink-0 w-12 h-12 md:w-14 md:h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform">
                <WhatsAppIcon size={22} />
            </span>
            <span className="flex flex-col leading-tight min-w-0">
                <span className="text-[10px] md:text-[11px] uppercase tracking-widest text-[#4FB8B0] font-bold mb-0.5 md:mb-1">
                    قناتنا على واتساب
                </span>
                <span className="font-heading text-sm md:text-base font-bold">
                    أسعار الذهب أولاً بأول؟
                </span>
                <span className="text-[11px] md:text-xs text-[#A8D5D0] mt-0.5 md:mt-1">
                    انضم الآن — تحديثات يومية
                </span>
            </span>
            <button
                onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setOpen(false);
                }}
                className="absolute -top-2 -start-2 bg-white text-[#0F2A28] rounded-full w-6 h-6 flex items-center justify-center shadow hover:bg-zinc-100"
                aria-label="إخفاء"
            >
                <X size={14} />
            </button>
        </a>
    );
}
